import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Checkbox from '../field/checkbox';

const OPTIONS = {
  default: [
    {
      label: 'Active',
      value: ''
    },
    // 'Expired',
    // 'Incoming',
    'Pending',
    // {
    //   label: 'Pending with Contingencies',
    //   value: 'Pending With Contingencies'
    // },
    // 'Rented',
    'Sold'
    // 'Terminated',
    // 'Withdrawn'
  ],

  residential_income: [
    {
      label: 'Active',
      value: ''
    },
    'Sold'
  ]
};

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked = input.value === props.value;

  return (
    <Checkbox
      {...checkboxProps}
      type="radio"
      checked={checked}
      onChange={e => {
        const { checked, value } = e.target;

        var newValue = checked ? value : '';

        return input.onChange(newValue);
      }}
    />
  );
}

class PreferenceFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { className, type, ...props } = this.props;
    const options = props.options[type] || props.options.default || props.options;

    return (
      <div
        className={cx(BS.justifyContentSpaceBetween, BS.dFlex, BS.flexWrap, className)}
      >
        {options.map(function (option, i) {
          return (
            <RenderCheckbox
              {...props}
              key={i}
              value={option.value !== undefined ? option.value : option}
              label={option.label || option}
            />
          );
        })}
      </div>
    );
  }
}

PreferenceFilter.defaultProps = {
  options: OPTIONS,
  type: undefined
};

export default PreferenceFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/status-filter.js